<li class="nav-item">
  <ng-content></ng-content>
</li>
